import React from 'react';

function InputComponent({ placeholder, value }) {
    return <input type="text" className="form-control" placeholder={placeholder} value={value} />;
}

export default InputComponent;
